import _objectSpread from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { jsx, Fragment } from 'react/jsx-runtime';
import { memo, useCallback, useMemo } from 'react';
import { FactionIdToName } from '../utils.js';
import useStyles from './ExternalSystem.styles.js';
import { useWarzoneMapSystem } from '../context/warzone-map.js';
var ExternalSystem = memo(function (_ref) {
  var solarsystemId = _ref.solarsystemId,
    classNames = _ref.classNames,
    styles = _ref.styles,
    unstyled = _ref.unstyled,
    onClick = _ref.onClick,
    _ref$radius = _ref.radius,
    radius = _ref$radius === void 0 ? 30 : _ref$radius;
  var _useWarzoneMapSystem = useWarzoneMapSystem(solarsystemId),
    data = _useWarzoneMapSystem.data,
    type = _useWarzoneMapSystem.type;
  var clickHandler = useCallback(function (event) {
    if (onClick) onClick(_objectSpread(_objectSpread({}, event), {}, {
      data: solarsystemId
    }));
  }, [onClick, solarsystemId]);
  var _useStyles = useStyles(void 0, {
      name: "WarzoneMapExternalSystem",
      classNames: classNames,
      styles: styles,
      unstyled: unstyled
    }),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  return useMemo(function () {
    var _a;
    if (type !== "external") return /* @__PURE__ */jsx(Fragment, {});
    var factionClass = data !== void 0 ? classes[(_a = FactionIdToName(data.reg.faction)) != null ? _a : "neutral"] : "";
    return /* @__PURE__ */jsx("circle", {
      id: "externalsystem-".concat(solarsystemId),
      cx: data.x,
      cy: data.y,
      r: radius,
      className: cx(classes.externalSystemDot, factionClass),
      onClick: clickHandler
    });
  }, [data, type, radius, clickHandler, classes, cx, solarsystemId]);
});
ExternalSystem.displayName = "WarzoneMapExternalSystem";
export { ExternalSystem };